function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.196078 0 0 0 0 0.474510 0 0 0 0 0.329412 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/other/medium/uparrow-Copy-3",
  transform: "translate(-1296.000000, -352.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1311.000000, 367.000000) scale(1, -1) translate(-1311.000000, -367.000000) translate(1296.000000, 352.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/other/medium/downarrow-Copy",
  transform: "translate(15.000000, 15.000000) scale(1, -1) translate(-15.000000, -15.000000) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.3650261,14.9664883 L20.3675326,5.96398172 C20.589047,5.74246736 20.589047,5.38753264 20.3675326,5.16601828 C20.1462272,4.94466057 19.7910836,4.94466057 19.5697781,5.16601828 L10.1660183,14.5697781 C9.94466057,14.7910836 9.94466057,15.1462272 10.1660183,15.3675326 L19.5697781,24.7670104 C19.6782898,24.8757311 19.8245561,24.9340601 19.9664883,24.9340601 C20.1084726,24.9340601 20.2547389,24.8798042 20.3634595,24.7670104 C20.584765,24.545705 20.584765,24.1905614 20.3634595,23.9692559 L11.3650261,14.9664883 Z",
  id: "Fill-1",
  stroke: "#3D3D3D",
  strokeWidth: 0.2,
  fill: "#3D3D3D",
  transform: "translate(15.266834, 14.967030) rotate(-90.000000) translate(-15.266834, -14.967030) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  x: 0,
  y: 0,
  width: 30,
  height: 30
})))));

function SvgUparrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54512257-FA06-429B-8832-32AA9499A696") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.840c5f2c.svg";
export { ForwardRef as ReactComponent };